<span class="search-tooltip" (mouseenter)="toggle(true)" (mouseleave)="toggle(false)">
  @if (toolinfo) {
  <div>
    <span class="info-icon">
      <lucide-icon [size]="16" name="info"></lucide-icon>
    </span>
    @if (showinfo) {
    <span class="tooltip-box"> {{ toolinfo }} </span>
    }
  </div>
  } @if (!toolinfo) {
  <div>
    <ng-content select="[tooltip-trigger]"></ng-content>
    @if (showinfo) {
    <div class="tooltip-box-breadcrumb">
      <ng-content></ng-content>
    </div>
    }
  </div>
  }
</span>
